<template>
  <div>
    <div class="breadcrumb">
      <ul>
        <li v-for="(bc, i) in breadcrumbs" :key="i" :class="{'linked': !!bc.link}">
          <router-link tag="li" :to="bc.link">
            <div v-if="i === book.breadcrumbs.length -1">
              <a style="text-decoration: none; color: black; font-weight: bold;">{{bc.name}}</a>
            </div>
            <a v-else style="text-decoration: none; color: black;">{{bc.name}}</a>
          </router-link>
        </li>
      </ul>
    </div>

    <v-card>
      <v-layout row wrap>
        <v-flex xs12 md4 pt-3 >
          <v-img :src="book.image" height="300px" contain></v-img>
        </v-flex>
        <v-flex xs12 md8>
          <v-card-title>
            <div>
              <div class="text-uppercase text-18-security green-security font-weight-bold" contain>{{ book.title }}</div>
              <div class="mt-3 text-16-security green-security font-weight-bold">Autor: {{ book.author }}</div>
              <div class="text-16-security green-security font-weight-bold">Editorial: {{ book.editorial.name }}</div>
              <div class="text-16-security green-security font-weight-bold">Unidades disponibles: {{ book.stock }}</div>
              <div v-html="book.description" class="mt-3 text-16-security"></div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn :block="getBreakpointBlock" style="background-color: rgb(33, 22, 81);" class="btn-security white--text" @click="newRequestBook()">SOLICITAR</v-btn>
          </v-card-actions>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  props: {
    book: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions({
      requestBook: "library/requestBook"
    }),
    newRequestBook() {
      Swal.fire({ 
        title: "Estas a punto de reservar el título " + this.book.title,
        imageUrl: this.book.image,
        imageWidth: 200,
        imageHeight: 250,
        width: 600,
        html:
          '<p>Por favor revisa tus datos y luego confirma tu reserva.</p>' +
          `<h4>Nombre: ${this.current_user.name} ${this.current_user.last_name}</h4>` +
          `<h4>Empresa: ${this.current_user.company}</h4>` +
          `<h4>Correo electrónico: ${this.current_user.email}</h4>` +
          `<h4>Anexo: ${this.current_user.annexed}</h4>` +
          `<h4>Dirección Sucursal: ${this.current_user.address}</h4>`,

        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          this.requestBook(this.book).then(() => {
            this.$router.push({ name: "library" });
            Swal.fire({
              title: "¡Solicitud exitosa!",
              text: "Tu solicitud fue realizada",
              type: "success",
              confirmButtonText: "Ok"
            });
          });
        }
      });

      // this.requestBook(this.book).then(() => {
      //   this.$router.push({ name: "library" });
      //   Swal({
      //     title: "¡Solicitud exitosa!",
      //     text: "Tu solicitud fue realizada",
      //     type: "success",
      //     confirmButtonText: "Ok"
      //   });
      // });
    }
  },
  computed: {
    ...mapState("user",["current_user"]),
    getBreakpointBlock(){
      switch(this.$vuetify.breakpoint.name){
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
      }
    },
    breadcrumbs() {
      return this.$vuetify.breakpoint.smAndDown ? this.book.breadcrumbs.slice(0, 2) : this.book.breadcrumbs 
    }
  }
}
</script>

<style scoped>
ul {
  display: flex;
  justify-content: left;
  list-style-type: none;
}
ul > li {
  display: flex;
  float: left;
  width: auto;
  color: default;
  font-weight: bold;
  font-size: 1.2em;
  cursor: default;
  align-items: center;
}
ul > li:not(:last-child)::after {
  content: ">";
  float: right;
  font-size: 1.2em;
  margin: 0 0.5em;
  color: light-default;
  cursor: default;
}
.linked {
  cursor: pointer;
  font-size: 1.2em;
  font-weight: normal;
}
</style>